/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { ListElectricitySpotPricesPathParameters } from 'api/actions/list-electricity-spot-prices/list-electricity-spot-prices-path-parameters';
import { ListElectricitySpotPricesResponse } from 'api/actions/list-electricity-spot-prices/list-electricity-spot-prices-response';

type ListElectricitySpotPricesQueryParameters = Record<string, any>;

/**
 * The path of the ListElectricitySpotPrices action.
 */
export const listElectricitySpotPricesActionPath = new SweetPath<keyof ListElectricitySpotPricesPathParameters>(
  '/electricity-spot-price/list',
  { path: '{param}' }
);

/**
 * Creates a contextualized ListElectricitySpotPrices actions.
 */
export default function createListElectricitySpotPricesAction(axios: AxiosInstance) {
  return function listElectricitySpotPricesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: ListElectricitySpotPricesQueryParameters } = {}) {
    const path = listElectricitySpotPricesActionPath.original;

    return axios.get<ListElectricitySpotPricesResponse, ListElectricitySpotPricesResponse>(path, {
      params: query,
      headers,
    });
  };
}
